// return menu uuids of particular revenue center
export const getRevenueCenterMenuUuids = (data, uuid) => {
  // current revenue Center
  const getRevenueCenter = data?.find(
    (revenueCenter) => revenueCenter?.uuid === uuid
  )

  // uuids of menus assigned to revenue center
  return getRevenueCenter?.menus?.map(({ uuid }) => uuid) ?? []
}
